import APIService from '@/services/APIService.js';

export default {
  listar() {
    return APIService.apiCall().get('/distribuidoras-aneel/listar');
  }
};
